@if (initialized) {
  <form [formGroup]="inputForm">
    <div class="container">
      <!-- Arrival Time -->
      <section>
        <div class="mat-body-2">Time:</div>
        @if (!editing) {
          <div class="mat-body">
            {{materialTestInspection.arrival_time | dateFormat: 'very-long'}} to
            {{materialTestInspection.departure_time | dateFormat: 'hh:mm a'}}
          </div>
        }
        @if (editing) {
          <div class="row">
            <mat-form-field>
              <mat-label>Arrival Time</mat-label>
              <input matInput autocomplete="off" [ngxTimepicker]="fromPicker" [format]="24" formControlName="arrival_time"
                [errorStateMatcher]="matcher" />
              <ngx-material-timepicker #fromPicker></ngx-material-timepicker>
              @if (inputForm.controls.arrival_time.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.arrival_time.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.arrival_time.errors.error}}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field>
              <mat-label>Departure Time</mat-label>
              <input matInput autocomplete="off" [ngxTimepicker]="toPicker" [format]="24" formControlName="departure_time"
                [errorStateMatcher]="matcher" />
              <ngx-material-timepicker #toPicker></ngx-material-timepicker>
              @if (inputForm.controls.departure_time.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.departure_time.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.departure_time.errors.error}}
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </section>
      <!-- /Time -->
      <!-- Break duration -->
      <section>
        <div class="mat-body-2">Break duration (Minutes):</div>
        @if (!editing) {
          <div class="mat-body">{{materialTestInspection.break_duration | durationFormat}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <mat-label>Break duration (Minutes)</mat-label>
            <input matInput formControlName="break_duration" [errorStateMatcher]="matcher" autocomplete="off">
            @if (inputForm.controls.break_duration.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.break_duration.hasError('error')) {
              <mat-error>
                {{inputForm.controls.break_duration.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /Break duration -->
      <!-- Pictures section -->
      <section>
        <div class="mat-body-2">Pictures:</div>
        <div class="preview-list">
          <app-file-uploader class="input-placeholder small" [disabled]="!editing" icon="image" accept="image/*"
            (complete)="onUploadComplete($event)">
          </app-file-uploader>
          @for (pic of materialTestInspection.pictures; track pic) {
            <div>
              <img [src]="pic.getThumbnail()" class="link"
                (click)="appSrv.openCarousel($event, materialTestInspection.pictures, pic)" />
              @if (editing) {
                <button mat-icon-button aria-label="Delete" title="Delete" class="hover-icon"
                  (click)="removePicture(pic)">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          }
        </div>
      </section>
      <!-- /Pictures section -->
      <!-- Comment section -->
      <section>
        <div class="mat-body-2">Note:</div>
        @if (!editing) {
          <div class="mat-body">{{materialTestInspection.comment}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <textarea matInput formControlName="comment" [errorStateMatcher]="matcher"></textarea>
            @if (inputForm.controls.comment.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.comment.hasError('error')) {
              <mat-error>
                {{inputForm.controls.comment.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /Comment section -->
      <!-- Form Actions -->
      <section>
        @if (editing) {
          <div class="row">
            <button mat-stroked-button color="accent" (click)="saveItem()">Save</button>
          </div>
        }
      </section>
      <!-- Form Actions -->
    </div>
  </form>
}
